// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DTYbs","controls":"styles_controls__3MPqQ","charLimit":"styles_charLimit__2HN2g","input":"styles_input__2zecR","send":"styles_send__2EbsF"};